import { combineReducers, Reducer } from 'redux';

import { appReducer } from './app/reducer';
import { authReducer } from './auth/reducer';
import { commonReducer } from './common/reducer';
import { signUpReducer } from './signup/reducer';
import { StoreState } from './types';
import { organisationReducer } from './organisation/reducer';
import { returnReducer } from './returns/reducer';
import { userReducer } from './user/reducer';
import { accountReducer } from './account/reducer';
import { vatReducer } from './vat/reducer';
import { vatCheckerReducer } from './vat-checker/reducer';
import { billingReducer } from './billing/reducer';
import { taxRatesReducer } from './tax-rates/reducer';
import { chartOfAccountsReducer } from './chart-of-accounts/reducer';
import { tifdReducer } from './tifd/reducer';
import { reconciliationReducer } from './reconciliation/reducer';
import { receiptRulesReducer } from './receipt-rules/reducer';

const rootReducer: Reducer<StoreState> = combineReducers<StoreState>({
  account: accountReducer,
  app: appReducer,
  auth: authReducer,
  common: commonReducer,
  signUp: signUpReducer,
  organisation: organisationReducer,
  reconciliation: reconciliationReducer,
  return: returnReducer,
  user: userReducer,
  vat: vatReducer,
  vatChecker: vatCheckerReducer,
  billing: billingReducer,
  taxRates: taxRatesReducer,
  chartOfAccounts: chartOfAccountsReducer,
  tifd: tifdReducer,
  receiptRules: receiptRulesReducer,
});

export default rootReducer;
